import { useEffect } from 'react';

export const useScrollClose = (callback: () => void) => {
  useEffect(() => {
    document.addEventListener('scroll', callback);
    return () => {
      document.removeEventListener('scroll', callback);
    };
  }, [callback]);
};
